import { NavigateFunction } from "react-router-dom";

export const goBack = (navigate: NavigateFunction, pathname: string) => {
  const parentPath = pathname.substring(0, pathname.lastIndexOf("/"));
  if (parentPath === "") {
    navigate("/dashboard");
  } else {
    navigate(parentPath);
  }
};
